// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsPlpAccountRegisterAccount {
    static getAttributeTypeMap() {
        return ScriptsPlpAccountRegisterAccount.attributeTypeMap;
    }
}
ScriptsPlpAccountRegisterAccount.discriminator = undefined;
ScriptsPlpAccountRegisterAccount.additionalProperties = false;
ScriptsPlpAccountRegisterAccount.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "dob",
        "baseName": "dob",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "password",
        "baseName": "password",
        "type": "string"
    },
    {
        "name": "confirmPassword",
        "baseName": "confirmPassword",
        "type": "string"
    },
];
//# sourceMappingURL=scriptsPlpAccountRegisterAccount.js.map